import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import {
  idsReducer,
  noopReducer,
  offersReducer,
  userReducer,
  seoDataReducer,
  propsReducer,
  comparisonReducer,
} from '../../reducers';
import { IApplicationState, TApplicationStateInitial, TReduxActions, TReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { IAnalytics } from '../../types/redux/analytics';
import { IPage } from '../../types/redux/page';
import { TComparisonAlbums } from '../../types/redux/comparisonAlbums';
import { INewbuildingsComparison } from '../../types/newbuildingsCompare';
import { DEFAULT_ALBUMS } from '../../services/comparisonAlbums';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(
  initialState: TApplicationStateInitial,
  context: IApplicationContext,
  debugEnabled: boolean,
) {
  const reducers = combineReducers({
    analytics: noopReducer<IAnalytics>({ abGroup: 0 }),
    notFoundUrl: noopReducer(''),
    offers: offersReducer,
    props: propsReducer,
    ids: idsReducer,
    page: noopReducer<IPage>({ comparePageType: 'offers', deviceType: 'desktop' }),
    comparison: comparisonReducer,
    comparisonAlbums: noopReducer<TComparisonAlbums>(DEFAULT_ALBUMS),
    newbuildingsComparison: noopReducer<INewbuildingsComparison>(null),
    seoData: seoDataReducer,
    user: userReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const middlewares = [withExtraArgument(context)];

  // oxlint-disable-next-line typescript/no-explicit-any
  const storeEnchancers = composeEnhancers(compose(applyMiddleware(...middlewares))) as any;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IApplicationState, {}>(
      reducers,
      initialState as IApplicationState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
